/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { styled } from '@superset-ui/core';
import cls from 'classnames';
import Lottie from 'react-lottie-player';
import loadingAnimation from 'viana-lottie.json';

export type PositionOption =
  | 'floating'
  | 'inline'
  | 'inline-centered'
  | 'normal';
export interface Props {
  position?: PositionOption;
  className?: string;
  image?: string;
}

const LoaderImg = styled.div`
  z-index: 99;
  position: relative;
  margin: auto auto auto auto;
  &.inline {
    margin: 0px;
    width: 30px;
  }
  &.inline-centered {
    margin: 0 auto;
    width: 30px;
    display: block;
  }
  &.floating {
    padding: 0;
    margin: 0;
    position: absolute;
    left: 50%;
    top: 0%;
    transform: translate(-50%, -50%);
    margin: auto auto auto 30%;
  }
`;
export default function Loading({ position = 'floating', className }: Props) {
  return (
    <LoaderImg>
      <Lottie
        className={cls(position, className)}
        role="status"
        aria-live="polite"
        aria-label="Loading"
        loop
        animationData={loadingAnimation}
        speed={0.75}
        play
        style={{ width: 70, height: 70 }}
      />
    </LoaderImg>
  );
}
